import React, { useContext } from 'react';
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { CentralProviderContext } from '../../../centralProviderContext/CentralProviderContext';
import { usePhoneView, TextField } from '@michelin/acid-components';
import { InputAdornment, makeStyles } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
var useStyles = makeStyles(function (theme) { return ({
    input: {
        marginTop: '8px',
    }
}); });
var SearchInput = function (props) {
    var t = useTranslation().t;
    var phoneView = usePhoneView();
    var classes = useStyles();
    var contextValue = useContext(CentralProviderContext);
    var pSearch = debounce(function (searchTerm) {
        props.onSearchTerm(searchTerm);
    }, 500);
    var performSearch = function (event) {
        pSearch(event.target.value);
    };
    if (!contextValue)
        return null;
    return (React.createElement(TextField, { onKeyUp: performSearch, placeholder: phoneView ? t('Enter a text to search and select criteria') : t('Enter a text to search and select one or more search criteria'), autoFocus: true, classes: { root: classes.input }, InputProps: {
            startAdornment: (React.createElement(InputAdornment, { position: "start" },
                React.createElement(SearchIcon, { style: { marginLeft: '10px', color: '#a6a6a6' } }))),
            disableUnderline: true
        }, inputProps: {
            style: { fontSize: phoneView ? '14px' : '20px' },
            autoComplete: "disabled",
        } }));
};
export default SearchInput;
//# sourceMappingURL=SearchInput.js.map